import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'accordion',
  templateUrl: './mi-accordion.component.html',
  styleUrls: ['./mi-accordion.component.scss']
})
export class MiAccordionComponent implements OnInit {
  @Input() options;
  @Input() menus: Menu[];
  
  
  ngOnInit() {
  
  }

  toggle(index: number) {
  
    this.menus[index].active = !this.menus[index].active;
  }
}


export class Menu {
  active: boolean = false;
  orderHeaderId: number ;
  orderNumber:number;
  orderSourceId:number;
  orderTrackStatus: any[];
}